/**
* Our Services JS
* -----------------------------------------------------------------------------
*
* All the JS for the Our Services component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
import Splide from '@splidejs/splide';
( function( app ) {
  const COMPONENT = {

    className: 'our-services',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      if ( $( '.our-services' ).length ) {
        $( '.our-services' ).each( function( index, element ) {
          const mobileToggle = element.querySelector( '.mobile-dropdown-toggle' );
          const tabContainer = element.querySelector( '.tab-container' );
          const selectedTabTitle = element.querySelector( '.selected-tab-title' );

          if ( mobileToggle && tabContainer ) {
            mobileToggle.addEventListener( 'click', function() {
              if ( window.innerWidth < 768 ) {
                tabContainer.classList.toggle( 'hidden' );
              }
            } );

            tabContainer.querySelectorAll( 'button' ).forEach( ( button ) => {
              button.addEventListener( 'click', function() {
                selectedTabTitle.textContent = this.textContent.trim();
                if ( window.innerWidth < 768 ) {
                  tabContainer.classList.add( 'hidden' );
                }
              } );
            } );
          }
        } );
      }

      if ( $( '.our-services-splide' ).length ) {
        $( '.our-services-splide' ).each( function( index, element ) {
          const splide = new Splide( element, {
            type: 'slide',
            perPage: 3,
            perMove: 1,
            gap: '1rem',
            pagination: false,
            breakpoints: {
              768: {
                perPage: 1,
              },
              1024: {
                perPage: 2,
              },
            },
          } );

          const bar = splide.root.querySelector( '.progress-bar' );

          splide.on( 'mounted move', function() {
            const end = splide.Components.Controller.getEnd() + 1;
            const rate = Math.min( ( splide.index + 1 ) / end, 1 );
            bar.style.width = String( 100 * rate ) + '%';
          } );

          splide.mount();
        } );
      }
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'our-services', COMPONENT );
} )( app );
